module.exports = __webpack_public_path__ + "static/media/icon_place.29835a8b.svg";